import { resolveDemoCallLink } from './resolve-demo-call-link.js';

export function getMenuLinkAttributes(linkObj) {
    const attributes = [];
    const href = resolveDemoCallLink(linkObj && linkObj.link ? linkObj.link : '#');
    attributes.push(`href="${href}"`);
    if (linkObj && linkObj.newTab) {
        attributes.push('target="_blank"');
        attributes.push('rel="noopener noreferrer"');
    }
    return attributes.join(' ');
}
